import {FC} from 'react'
import DiscountCode from './DiscountCode'
import PromoCode from './PromoCode'
import WineClubDiscountButton from './WineClubDiscountButton'

type Props = {
  onSubmit?: (discountCode: any) => any
  title: string | any
  discountCodeId?: string | any
  onRemoveDiscount?: (discountCodeId: string | any) => any
  children?: React.ReactNode
  onClick: () => void
  isWineClub?: boolean
  show: boolean
}

const Discount: FC<Props> = ({
  onSubmit,
  title = 'Discount',
  discountCodeId,
  onRemoveDiscount,
  children,
  isWineClub = false,
  onClick,
  show,
}) => {
  return (
    <>
      {isWineClub ? (
        <WineClubDiscountButton onClick={onClick} title={title} isCursorDefault={!discountCodeId} />
      ) : (
        <PromoCode
          onClick={onClick}
          title={title}
          onRemoveDiscount={onRemoveDiscount}
          discountCodeId={discountCodeId}
        />
      )}
      {show && (children ? children : onSubmit && <DiscountCode onSubmit={onSubmit} />)}
    </>
  )
}
export default Discount
